<div class="picker-input-row">
	<mat-form-field appearance="outline" class="picker-half-size-field picker-inline-field">
		<mat-label class="mat-body-1">{{ 'timezone-picker.country' | translate }}</mat-label>
		<mat-select [(ngModel)]="selectedCountry" (selectionChange)="onCountryChange()">
			@for (country of countries; track country) {
				<mat-option [value]="country">{{ country }}</mat-option>
			}
		</mat-select>
	</mat-form-field>

	<mat-form-field appearance="outline" class="picker-half-size-field picker-inline-field">
		<mat-label class="mat-body-1">
			{{ 'timezone-picker.region' | translate }}
			{{ timeZoneId ? '(' + timeZoneId + ')' : '' }}
		</mat-label>
		<mat-select [(ngModel)]="selectedRegion" (selectionChange)="onRegionChange()">
			@for (region of regions; track region) {
				<mat-option [value]="region.name">{{ region.name }}</mat-option>
			}
		</mat-select>
	</mat-form-field>
</div>
